import { createAction, createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';
import { ProjectMappedWithFeature, ProjectMappedWithSource } from '../../components/DataGrid/reports.types';

export interface Report {
	projectName: string;
	activityType: string;
	activityDuration: number;
	comments: string;
	activityDate: string;
	workDescription: string;
	reportId: string;
	email: string;
	picture: string;
	userName: string;
	feature: string;
	isource: string;
	displayProjectName: string;
	workMode: string;
}

type ReportState = {
	count: number,
	reports: Report[],
	features: ProjectMappedWithFeature;
	isource: ProjectMappedWithSource;
	exceptions: Exception[];
	todayWorkHours: number;
	weekWorkHours: number;
}

type Exception = {
	date: string,
	duration: number
}

const initialState: ReportState = {
	count: 0,
	reports: [],
	features: {},
	isource:{},
	todayWorkHours: 0,
	weekWorkHours: 0,
	exceptions: []
};

export const addFeatureAction = createAction<{projectName: string, feature: string, isource: string}>('reports/addFeature');

const reportsReducer = createSlice({
	name: 'reports',
	initialState,
	reducers: {
		setReports: (state, action) => {
			state = {...state, ...action.payload};
			return state;
		},
		addReport: (state, action) => {
			const {report, count} = action.payload;
			state.reports = [report, ...state.reports];
			state.count = count;

			const {feature, isource, projectName} = report;

			if(!state.features[projectName]) {
				state.features[projectName] = [];
			}

			if(feature) {
				!state.features[projectName].includes(feature)
				? state.features[projectName].push(feature)
				: null;
			}

			if(!state.isource[projectName]) {
				state.isource[projectName] = [];
			}

			if(isource) {
				!state.isource[projectName].includes(isource)
				? state.isource[projectName].push(isource)
				: null;
			}

		},
		addMultipleReports(state, action) {

			state.reports = [...state.reports, ...action.payload];

			return state;
		},
		updateReport: (state, action) => {

			const indexOfReportToChange = state.reports.findIndex(report => report.reportId === action.payload.reportId);
			const changedReport = action.payload;

			state.reports[indexOfReportToChange] = changedReport;
			return state;
		},
		deleteReport: (state, action) => {

			const indexOfReportToDelete = state.reports.findIndex(report => report.reportId === action.payload);

			if (indexOfReportToDelete !== -1) {

				const savedReports = state.reports;

				// removing item using slice since its faster than filter
				state.reports = [
					...savedReports.slice(0, indexOfReportToDelete),
					...savedReports.slice(indexOfReportToDelete + 1)];
			}
			return state;
		}
	},
	extraReducers(builder) {
		builder
			.addCase(revertAll, () => initialState)
			.addCase(addFeatureAction, (state, action) => {

				const {projectName, feature, isource} = action.payload;

				if(!state.features[projectName]) {
					state.features[projectName] = [];
				}
				if(!state.isource[projectName]) {
					state.isource[projectName] = [];
				}
				state.isource[projectName].push(isource);
				state.features[projectName].push(feature);
			});
	}
});

export const { setReports, addReport, updateReport, deleteReport, addMultipleReports } = reportsReducer.actions;
export default reportsReducer;
